import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SvgIcon from "@components/common/SvgIcon/SvgIcon";
import LanguageSelector from "@components/LanguageSelector/LanguageSelector";
import { ROUTES } from "constants/routes";
import { ChevronRightIcon, LogoIcon } from "@assets/icons";
import P from "@components/common/P/P";
import { STORAGE_KEYS } from "constants/storageKeys";

const LANGUAGE_LABELS: Record<string, string> = {
	ru: "Рус",
	en: "Eng",
	tr: "Tür",
};

const Navbar: React.FC = () => {
	const navigate = useNavigate();
	const { i18n } = useTranslation();
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const panelType =
		localStorage.getItem(STORAGE_KEYS.ADMIN_PANEL_TYPE) || "landing";
	const isLanding = panelType === "landing";

	const toggleAdminPanelType = () => {
		const current =
			localStorage.getItem(STORAGE_KEYS.ADMIN_PANEL_TYPE) || "landing";
		const next = current === "landing" ? "platform" : "landing";
		localStorage.setItem(STORAGE_KEYS.ADMIN_PANEL_TYPE, next);
		navigate(ROUTES.HOME);
		window.location.reload(); // or trigger context/state if avoiding full reload
	};

	const selectedLanguage = {
		code: i18n.language,
		label: LANGUAGE_LABELS[i18n.language] || LANGUAGE_LABELS.ru,
	};

	const handleLanguageChange = (language: { code: string; label: string }) => {
		i18n.changeLanguage(language.code);
		setIsDropdownOpen(false);
	};

	return (
		<header className="w-full px-6 fixed py-4 border-b border-strokeLanding bg-white z-[99]">
			<div className="grid gap-8 grid-cols-maxTwo place-content-between place-items-center">
				<Link to={ROUTES.HOME}>
					<SvgIcon Icon={LogoIcon} width={86} height={32} />
				</Link>

				<div className="grid items-center gap-4 grid-cols-maxTwo">
					<LanguageSelector
						isDropdownOpen={isDropdownOpen}
						setIsDropdownOpen={setIsDropdownOpen}
						selectedLanguage={selectedLanguage}
						handleLanguageChange={handleLanguageChange}
						isScrolled={false}
					/>
					{/* <div
						className="grid grid-cols-maxTwo gap-2 place-items-center cursor-pointer py-2 px-1.5 rounded-xl bg-shadeOne"
						onClick={toggleAdminPanelType}
					>
						<P size="t1" type="medium" className="cursor-pointer">
							{isLanding ? "Мониторинг сайта" : "Ландинг сайта"}
						</P>
						<SvgIcon
							Icon={ChevronRightIcon}
							width={18}
							height={18}
							stroke="currentColor"
						/>
					</div> */}
				</div>
			</div>
		</header>
	);
};

export default React.memo(Navbar);
